<template>
  <v-container fluid fill-heightv>
    <v-layout row wrap>
      <v-flex xs12 class="print">
        <div>
          <v-layout row>
            <h1> Consolidação</h1>
          </v-layout>
          <hr/>
          <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="date"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="computedDateFormattedMomentjs"
                  label=""
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                type="month"
                locale="pt-br"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
              </v-date-picker>
            </v-menu>
        </div>
        <v-data-table
          v-if="posto"
          hide-actions
          :hide-headers="!diasAtividadeMes.length"
          :loading="loading"
          :items="diasAtividadeMes"
          class="elevation-0"
          style="overflow-hidden"
        >
          <v-alert v-slot:no-results :value="true" color="error" icon="warning">
            Desculpe, não encontramos nenhum dado!
          </v-alert>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left px-3">
                <strong>{{props.item.date}}</strong>
              </td>
              <td class="text-xs-center px-4" style="width: 10px">
                <consolidar-pagamentos @consolidarPagamento="fecharDia" :fechado="props.item.fechado" :dia="props.item.date"></consolidar-pagamentos>
              </td>
              <td class="text-xs-center px-4" style="width: 10px">
                <consolidar-abastecimentos @consolidarAbastecimento="fecharDiaAbastecimento" :fechado="props.item.fechadoAbastecimento" :dia="props.item.date"></consolidar-abastecimentos>
              </td>
            </tr>
          </template>
          <template v-slot:headers>
            <tr>
              <th class="text-xs-left px-3">
                Mês
              </th>
              <th class="text-xs-center px-4">
                Pagamentos
              </th>
              <th class="text-xs-center px-4">
                Abastecimentos
              </th>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ConsolidarPagamentos from '@/components/ConsolidarPagamentos'
import ConsolidarAbastecimentos from '@/components/ConsolidarAbastecimentos'
import moment from 'moment'

export default {
  components: { ConsolidarPagamentos, ConsolidarAbastecimentos },
  data () {
    let today = moment().startOf('month')
    return {
      date: today.toISOString().substr(0, 7),
      menu: false,
      month: today,
      diasAbastecimentoFechados: {},
      diasFechados: {},
      automacao: null
    }
  },
  watch: {
    computedDateFormattedMomentjs (val) {
      this.month = moment(val, `MMMM YYYY`)
    },
    date (val) {
      if (val !== null && val !== undefined) {
        this.carregarConsolidacoes(val)
      }
    },
    posto (val) {
      if (val !== null & val !== undefined) {
        this.carregarConsolidacoes(this.date)
      }
    }
  },
  computed: {
    computedDateFormattedMomentjs () {
      return this.date ? moment(this.date).format(`MMMM YYYY`) : ''
    },
    loading () {
      return this.$store.getters.loading
    },
    consolidacao () {
      return this.$store.getters.consolidacao
    },
    posto () {
      return this.$store.getters.posto
    },
    diasAtividadeMes () {
      let days = []
      let currentDay = this.month ? this.month.clone().startOf('month') : moment().startOf('month')
      let endDay = this.month ? this.month.clone().endOf('month') : moment().endOf('month')
      let today = moment()
      if (today < endDay) endDay = today

      while (currentDay <= endDay) {
        let date = currentDay.format('DD/MM/YYYY')
        let day = {
          fechado: !!this.diasFechados[date],
          fechadoAbastecimento: !!this.diasAbastecimentoFechados[date],
          date: date
        }
        days.unshift(day)
        currentDay = currentDay.add(1, 'day')
      }

      return days
    }
  },
  methods: {
    fecharDia (dia) {
      this.diasFechados[dia] = true
      this.diasFechados = { ...this.diasFechados }
    },
    fecharDiaAbastecimento (dia) {
      this.diasAbastecimentoFechados[dia] = true
      this.diasAbastecimentoFechados = { ...this.diasAbastecimentoFechados }
    },
    carregarConsolidacoes (mes) {
      let start = moment(mes).startOf('month').format('DD/MM/YYYY')
      let end = moment(mes).endOf('month').format('DD/MM/YYYY')
      this.$store.dispatch('getConsolidacoes', { start: start, end: end }).then((consolidacoes) => {
        let diasFechados = {}
        let diasAbastecimentoFechados = {}
        consolidacoes.consolidacoes_pagamento.forEach(item => {
          diasFechados[moment(item.data_consolidacao).format('DD/MM/YYYY')] = true
        })
        consolidacoes.consolidacoes_abastecimento.forEach(item => {
          diasAbastecimentoFechados[moment(item.data_consolidacao).format('DD/MM/YYYY')] = true
        })
        this.diasAbastecimentoFechados = { ...diasAbastecimentoFechados }
        this.diasFechados = { ...diasFechados }
      })
    }
  }
}
</script>
